import { Get, Post } from "../../utils/http-utils";
import { SCM_DESTINATION_PATH } from "../../utils/constants";

export const getAssetTypes = async () => {
    return Get("/scm/thing-type")
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const getAllThings = async () => {
  return Get("/scm/thing")
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const getJobType = () => {
    return Object.keys(SCM_DESTINATION_PATH);
}

export const getDestinationByKey = (key) => {
    return SCM_DESTINATION_PATH[key] || null;
};
